var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeature82(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 48,
    viewBox: "0 0 45 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_019-cube",
    "data-name": "019-cube",
    transform: "translate(-30 -22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_244",
    "data-name": "Path 244",
    d: "M74.372,37.28l-21-15a1.5,1.5,0,0,0-1.744,0l-21,15A1.5,1.5,0,0,0,30,38.5v15a1.5,1.5,0,0,0,.628,1.221l21,15a1.495,1.495,0,0,0,1.744,0h0l21-15A1.5,1.5,0,0,0,75,53.5v-15a1.5,1.5,0,0,0-.629-1.22ZM52.5,25.344,70.919,38.5,52.5,51.657,34.081,38.5ZM33,52.729V41.415L51,54.272V65.586ZM54,65.586V54.272L72,41.415V52.729Z",
    fill: "#727272"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_245",
    "data-name": "Path 245",
    d: "M104.372,65.137l-12-8.571a1.5,1.5,0,0,0-1.744,0l-12,8.571a1.5,1.5,0,0,0,0,2.441l12,8.571a1.5,1.5,0,0,0,1.743,0l12-8.571a1.5,1.5,0,0,0,0-2.441ZM90,60.7V72.014l-7.919-5.657Zm3,11.313V60.7l7.919,5.657Z",
    transform: "translate(-39 -27.857)",
    fill: "#051ee1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature82);
export default __webpack_public_path__ + "static/media/feature_8_2.9c6b3d45f584a750d31b9012e0cff735.svg";
export { ForwardRef as ReactComponent };